import { render, staticRenderFns } from "./WaitingListDetails.vue?vue&type=template&id=b94053de&scoped=true&"
import script from "./WaitingListDetails.vue?vue&type=script&lang=ts&"
export * from "./WaitingListDetails.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingListDetails.vue?vue&type=style&index=0&id=b94053de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94053de",
  null
  
)

export default component.exports